import axios from "axios";

export default {
  obtenerCarreras: function(token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Apuestas/ObtenerCarreras`,
        {},
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  obtenerTiposApuestas: function(carreraId, token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Apuestas/ObtenerTiposApuestas`,
        {
          carreraId
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  obtenerCompetidores: function(carreraId, tipoApuestaId, token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Apuestas/ObtenerCompetidores`,
        {
          carreraId,
          tipoApuestaId
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  obtenerCantidadItems: function(carreraId, tipoApuestaId, pases, token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Apuestas/ObtenerCantidadItems`,
        {
          carreraId,
          tipoApuestaId,
          pases
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  ingresarApuesta: function(carreraId, tipoApuestaId, pases, cantidadVales, token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Apuestas/IngresarApuesta`,
        {
          carreraId: carreraId,
          tipoApuestaId: tipoApuestaId,
          pases: pases,
          cantidadVales: cantidadVales
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  obtenerCarrerasResultado: function(token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Apuestas/ObtenerCarrerasResultado`,
        {},
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  obtenerSportsCarrera: function(carreraId, token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Apuestas/ObtenerResultados`,
        {
          carreraId
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  obtenerApuesta: function(id, token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Apuestas/ObtenerApuesta`,
        {
          id
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  anularApuesta: function(id, token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Apuestas/AnularApuesta`,
        {
          id
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  }
};
